import { graphql, useStaticQuery } from 'gatsby';

type NavLink = {
	name: string;
	path: string;
};

type SiteMetadata = {
	title: string;
	shortTitle: string;
	description: string;
	twitterUsername: string;
	image: string;
	siteUrl: string;
	navigation: NavLink[];
	footerLinks: NavLink[];
	social: {
		facebook: string;
		github: string;
		mastodon: string;
		twitter: string;
		telegram: string;
		substack: string;
		bsky: string;
		dailydev: string;
	};
};

type graphqlResult = {
	site: {
		siteMetadata: SiteMetadata;
	};
};

export const useSiteMetadata = (): SiteMetadata => {
	const data: graphqlResult = useStaticQuery(graphql`
		{
			site {
				siteMetadata {
					title
					shortTitle
					description
					twitterUsername
					image
					siteUrl
					navigation {
						name
						path
					}
					footerLinks {
						name
						path
					}
					social {
						facebook
						github
						mastodon
						twitter
						telegram
						substack
						bsky
						dailydev
					}
				}
			}
		}
	`);

	return data.site.siteMetadata;
};
